import(/* webpackMode: "eager" */ "/Users/whw/Desktop/fugufish/vgw-website/frontend/src/app/global-error.jsx");
